import { useFishingDiscipline, disciplineLabel } from "../../types/fishingDiscipline";
import PublicDisciplineLayout from "../../components/publicSite/PublicDisciplineLayout";
import CompetitionCard from "../../components/publicSite/CompetitionCard";
import { useState, useEffect } from "react";
import { PublicApiService, Competition } from "../../services/publiApiService";

const PAGE_SIZE = 10;

export default function CompetitionsPage() {
  const discipline = useFishingDiscipline();
  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState<"name" | "date">("date");
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("desc");
  const [competitions, setCompetitions] = useState<Competition[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    let active = true;
    setLoading(true); setError("");
    PublicApiService.getCompetitions(currentPage, PAGE_SIZE, sortField === "name" ? "Name" : "CompetitionDate", sortDirection === "desc", discipline)
      .then(result => { if (active) { setCompetitions(result.results); setTotalPages(result.totalPages || 1); } })
      .catch(() => { if (active) setError("Impossibile caricare il calendario gare. Riprova tra poco."); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [currentPage, sortField, sortDirection, discipline, retry]);

  return <PublicDisciplineLayout title={`Gare ${disciplineLabel(discipline)}`} intro="Tutte le date, le locandine e i risultati. Scegli una gara per partecipare o consultare la classifica.">
    <div>
      <div className="site-toolbar">
        <p>Il calendario delle gare</p>
        <div className="site-sort">
          <label className="site-field"><span>Ordina per</span>
            <select value={sortField} onChange={event => { setSortField(event.target.value as "name" | "date"); setCurrentPage(1); }}>
              <option value="date">Data</option><option value="name">Nome</option>
            </select>
          </label>
          <button type="button" className="site-button site-button--secondary"
            onClick={() => { setSortDirection(direction => direction === "asc" ? "desc" : "asc"); setCurrentPage(1); }}
            aria-label={sortDirection === "asc" ? "Ordina decrescente" : "Ordina crescente"}
            title={sortDirection === "asc" ? "Ordine crescente" : "Ordine decrescente"}>
            <span aria-hidden="true">{sortDirection === "asc" ? "↑" : "↓"}</span>
          </button>
        </div>
      </div>
      {loading ? <p role="status" className="site-notice">Caricamento calendario…</p>
        : error ? <div role="alert" className="site-notice site-notice--error"><p>{error}</p><button className="site-button site-button--secondary mt-4" onClick={() => setRetry(value => value + 1)}>Riprova</button></div>
        : !competitions.length ? <p className="site-notice">Nessuna gara trovata.</p>
        : <div className="race-grid">{competitions.map(competition => <CompetitionCard key={competition.id}
          id={competition.id} name={competition.name} league={competition.leagueName || ""}
          date={competition.competitionDate?.slice(0, 10) || ""} location={competition.location} type={competition.type}
          description={competition.description || ""} urlLocandina={competition.urlLocandina} resultsPublished={competition.resultsPublished}
        />)}</div>}
      {!loading && !error && totalPages > 1 && <nav className="site-pagination" aria-label="Pagine del calendario">
        <button className="site-button site-button--secondary" onClick={() => setCurrentPage(page => page - 1)} disabled={currentPage === 1} aria-label="Pagina precedente">←</button>
        {Array.from({ length: totalPages }, (_, index) => <button key={index} className="site-button site-button--secondary" aria-label={`Pagina ${index + 1}`} aria-current={currentPage === index + 1 ? "page" : undefined} onClick={() => setCurrentPage(index + 1)}>{index + 1}</button>)}
        <button className="site-button site-button--secondary" onClick={() => setCurrentPage(page => page + 1)} disabled={currentPage === totalPages} aria-label="Pagina successiva">→</button>
      </nav>}
    </div>
  </PublicDisciplineLayout>;
}
